<template>
    <div class="navbar">
        <div class="userinfo">
             <!-- <el-dropdown @command="this.handleCommand">
                <span class="el-dropdown-link">
                    {{user.name}}
                    <img src="../../assets/user.png" />
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
               <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="userinfo">个人资料</el-dropdown-item>
                    <el-dropdown-item command="password">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  methods: {
    handleCommand (command) {
      if (command === 'password') {
        this.$router.push({path: '/staff/main/password'})
      } else if (command === 'logout') {
        this.api.staff.logout({}).then((response) => {
          this.$store.commit('logout')
        })
      }
    }
  },
  computed: {
    ...mapState(['user'])
  }
}
</script>

<style scoped>
.navbar {
    height: 80px;
    background: #fff;
    width: 100%;
}

.userinfo {
    float: right;
    padding-right: 25px;
    line-height: 80px;
}

.navbar img {
    width: 40px;
    height: 40px;
    border-radius: 25px;
    margin-top: 20px;
    margin-right: 8px;
    float: left;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?3f212513